import { type FC, useEffect } from "react";

import { CinLoaderFull } from "@cinnamon/design-system/blocks";
import styled from "@emotion/styled";

import { useAppDispatch, useAppSelector } from "@/redux/hook";
import { getSessionInfo } from "@/redux/reducer/userSlice";
import { featureFlagState, userState } from "@/redux/store";
import Route from "@/routes";

import { fetchAllFeatureFlags } from "./redux/reducer/featureFlagSlice";

const Box = styled.div`
  display: flex;
  max-width: 100%;
`;

const App: FC = () => {
  const dispatch = useAppDispatch();
  const { isInitialized } = useAppSelector(userState);
  const { loading: featureFlagLoading } = useAppSelector(featureFlagState);

  useEffect(() => {
    void dispatch(getSessionInfo());
    void dispatch(fetchAllFeatureFlags());
  }, [dispatch]);

  if (!isInitialized || featureFlagLoading) return <CinLoaderFull />;

  return (
    <Box id="global-wrapper">
      <Route />
    </Box>
  );
};

export default App;
